import { render, staticRenderFns } from "./HandoverProtocol.yaml?vue&type=template&id=2df6abd2&component"
import script from "./HandoverProtocol.yaml?vue&type=script&lang=ts&component"
export * from "./HandoverProtocol.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports